import { ReactComponent as Warning } from "./warning-icon.svg";

const WarningIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <Warning {...props} />;

export default WarningIcon;
